import { SiteConfigurationTemplate, TagMapping } from '../types';
import { isForwardedInTag } from './isForwardedInTag';

export const buildAutoMapping = (
  template: SiteConfigurationTemplate,
  destinationTags: { id: string; rawInputName: string; displayName: string | null }[]
): TagMapping => {
  const mapping: TagMapping = {};
  for (const gw of template.gateways) {
    for (const [rawInputName, tag] of Object.entries(gw.tags)) {
      if (isForwardedInTag(tag)) continue;
      const match = destinationTags.find(
        (dt) =>
          dt.rawInputName === rawInputName ||
          (dt.displayName && tag.displayName && dt.displayName === tag.displayName)
      );
      mapping[tag.idempotencyKey] = match?.id ?? '';
    }
  }
  return mapping;
};
